<template>
  <span class="afd-message-filter-component">
    <div v-if="filterAgencies" class="filter-option">
        Maatschappij
      <select-agency-component @agency-selected="onAgenciesSelect"
                               :key="filterKey"
                               :selected-agency-ids="filters.agencies"
                               :disabled="disableFilters" :multiple="true"
                               style="display: inline-block; min-width: 330px;"></select-agency-component>
    </div>
    <div v-if="filterCustomer" class="filter-option">
        Klant
        <customer-select v-model="filters.customer" :key="filterKey" :disabled="disableFilters"
                         @change="onCustomerSelect"
                         :allow-clear="true" style="display: inline-block; min-width: 330px"></customer-select>
    </div>
    <div v-if="filterDateRange" class="filter-option">
      Periode
      <a-range-picker
              :disabled="disableFilters" :key="filterKey"
              :default-picker-value="[moment().subtract(1, 'months'), moment()]"
              :placeholder="['Startdatum', 'Einddatum']"
              :ranges="{
            'Vorige maand': [
                moment().subtract(1, 'months').startOf('month'),
                moment().subtract(1, 'months').endOf('month')
              ],
            'Deze maand': [
                moment().startOf('month'),
                moment().endOf('month')
              ],
           }"
              format="DD-MM-YYYY"
              style="width: 220px"
              @change="onDateRangeSelect">
        <a-icon slot="suffixIcon" type="calendar"/>
      </a-range-picker>
    </div>
    <div class="filter-option">
      <div style="display: flex">
        <a-button :disabled="disableFilters" @click="resetFilter">Verwijder alle filters</a-button>
      </div>
    </div>
  </span>
</template>

<script>
import locale from "ant-design-vue/es/date-picker/locale/nl_NL";
import moment from "moment";
import DateFormatEnum from "~/enums/DateFormatEnum";
import SelectAgencyComponent from "../../agency/components/SelectAgencyComponent.vue";

export default {
  name: "AfdMessageFilterComponent",
  components: {SelectAgencyComponent},
  props: {
    disableFilters: {
      type: Boolean,
      default: false,
    },
    filterAgencies: {
      type: Boolean,
      default: false
    },
    filterCustomer: {
      type: Boolean,
      default: false
    },
    filterDateRange: {
      type: Boolean,
      default: false
    },
    initialFilters: {
      default: null
    }
  },
  data() {
    return {
      filterKey: 1,
      filters: {},
      locale,
    };
  },
  methods: {
    filter() {
      this.$emit("filter", this.filters);
    },
    moment,
    onAgenciesSelect(values) {
      Object.assign(this.filters, {agencies: values.map(value => value.key)});
      this.filter();
    },
    onCustomerSelect(value) {
      Object.assign(this.filters, {customer: value});
      this.filter();
    },
    onDateRangeSelect(date) {
      this.filters.date_range = {};
      if (date.length) {
        this.filters.date_range["start"] = date[0].startOf("day")
          .format(DateFormatEnum.ISO8601);
        this.filters.date_range["end"] = date[1].endOf("day")
          .format(DateFormatEnum.ISO8601);
      }
      this.filter();
    },
    resetFilter() {
      this.filters = {
        agencies: [],
        customer: null,
        date_range: {},
      };
      this.filterKey += 1;
      this.filter();
    },
  },
  created() {
    if (this.initialFilters === null) {
      this.resetFilter();
    } else {
      this.filters = this.initialFilters
      this.filter();
    }
  }
}
</script>

<style scoped>
.filter-option {
    display: inline-block;
    margin-left: 15px;
    height: 45px
}
</style>
